import React, { useState, useEffect, useContext, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import useLocality from '../../../../hooks/useLocality';
import { ProjectContext } from '../../../../context/Project';
import {
	Container,
	Row,
	Col,
	Input,
	Button,
	FormGroup,
	Label,
	Progress,
	FormFeedback
} from "reactstrap";
import './steps.scss';

function LocationStep() {
	const navigate = useNavigate();
	const [zipCode, setZipcode] = useState('');
	const [zipCodeValid, setZipcodeValid] = useState(false);
	const [zipCodeLocality, setZipcodeLocality] = useState('');
	
	const localityHelper = useLocality();
	const { setLocation, setPostalCode, getPostalCode } = useContext(ProjectContext);
	const zipCodeLengthValid = zipCode.length > 4;

	const handleZipCodeChange = (event) => {
        setZipcode(event.target.value);
		setZipcodeLocality('');
    }

	const handleSubmit = (event) => {
		event.preventDefault();
	}

	useEffect(() => {
		let postalCode = getPostalCode();

		if (postalCode) {
			setZipcode(postalCode)
		}
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

	useEffect(() => {
		if (zipCodeLengthValid) {
			localityHelper.getByPostalCode(1, zipCode);
		} else {
			setZipcodeValid(false);
		}
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zipCode]);

	useEffect(() => {
		if (!zipCodeValid) {
			setLocation(null);
			setPostalCode(null);
		}
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zipCodeValid]);

	useEffect(() => {
		if(localityHelper.loading) {
			return;
		}

        if(localityHelper.localitiesByPostalCode && localityHelper.localitiesByPostalCode.length) {
			const localityData = localityHelper.localitiesByPostalCode.find(() => true);
			setZipcodeValid(true);
			setLocation(localityData);
			setPostalCode(zipCode);
			setZipcodeLocality(`${localityData.name}, ${localityData.administrativeAreaName}`);
        } else {
			setZipcodeValid(false);
		}
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [localityHelper.localitiesByPostalCode]);

    return (
    	<Fragment>
	        <nav id="topbar">
	    		<Container className="builde-cont">
			    	<Row>
		    			<Col xs={{size: 12}}>
		    				<div className="cont-topbar">
		    					<Button className="btn-back" onClick={() => navigate(-1)}></Button>
		    					<h3>Project location</h3>
		    				</div>
		    			</Col>
			    	</Row>
		    	</Container>
	    	</nav>
	    	<section id="progress-bar">
	    		<Container className="builde-cont">
			    	<Row>
		    			<Col xs={{size: 12}}>
	    					<Progress value={12}></Progress>
		    			</Col>
			    	</Row>
		    	</Container>
	    	</section>
	    	<form className="m-t-20 form-base-dis" onSubmit={handleSubmit}>
	    		<Container className="builde-cont">
			    	<Row>
		    			<Col xs={{size: 12}}>
		    				<h1>First, enter the project location to estimate a budget</h1>
		    				<FormGroup floating className="m-t-30">
								<Input
									id="zipcode"
									name="zipcode"
									placeholder="ZIP code"
									type="text"
									value={zipCode}
									onChange={handleZipCodeChange}
									valid={zipCodeValid}
								/>
								<Label for="zipcode">
									ZIP code
								</Label>
								{
									(zipCodeValid && zipCodeLocality) &&
									<FormFeedback valid>
										{zipCodeLocality}
								  	</FormFeedback>
								}
						    </FormGroup>
		    			</Col>
			    	</Row>
					<Row>
						<Col xs={{ size: 12 }}>
							<span>
								Currently, our app is available only for Chicago area zip codes.
								Please enter a zip code from the Chicago area or choose one of the options below to explore our app.
							</span>
						</Col>
						<Col xs={{ size: 12 }}>
							<span className='text-bold'>
								{'=>'}
							</span>
							<span className='fw-bold'>
								{' '} 60610, 60601, 60613, 60624, 60203, 60301, 60076
							</span>
						</Col>
					</Row>
			    	<Row>
			    		<Col xs={{size: 12}}>
			    			<div className="d-grid gap-2 m-t-260">
			    				<Button
									color="primary"
									size="lg"
									disabled={!zipCodeValid}
									onClick={() => {
										navigate(
											'/project/create/estimate-budget'
										)
									}}
								>Continue</Button>
			    			</div>
			    		</Col>
			    	</Row>
		    	</Container>
	    	</form>
    	</Fragment>
    );
}

export default LocationStep;